import { render, staticRenderFns } from "./CategoriesModal.vue?vue&type=template&id=78c351a7"
import script from "./CategoriesModal.vue?vue&type=script&lang=js"
export * from "./CategoriesModal.vue?vue&type=script&lang=js"
import style0 from "./CategoriesModal.vue?vue&type=style&index=0&id=78c351a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports